import { render, staticRenderFns } from "./ProjectDetailPage.vue?vue&type=template&id=7380bbc3&scoped=true"
import script from "./ProjectDetailPage.vue?vue&type=script&lang=js"
export * from "./ProjectDetailPage.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/projectDetail.scss?vue&type=style&index=0&id=7380bbc3&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7380bbc3",
  null
  
)

export default component.exports